import { TodayPaymentLine } from "./TodayPaymentLine";
import { TotalDueTodayLine } from "./TotalDueTodayLine";

export const InstallmentsLines = Object.assign(
  {},
  {
    TodayPaymentLine,
    TotalDueTodayLine,
  },
);
